import React from 'react';
import { useIntl, FormattedDate } from 'react-intl';
import {
  Button,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Checkbox,
} from '@material-ui/core';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import { makeStyles } from '@material-ui/core/styles';
import messages from 'messages';

import { ExportMenu } from 'components/ExportMenu';
import DeleteButton from '../../ListView/DeleteButton.js';
import { getFormResponseStatusIcon } from '../../../formUtils.js';

const useStyles = makeStyles((theme) => ({
  listRoot: {
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  listItem: {
    border: '1px solid rgba(0,0,0,0.2)',
    '&.MuiListItem-secondaryAction': {
      paddingRight: '96px',
    },
  },
  secondary: {
    right: '0px',
  },
  listIcon: {
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
      margin: '0 5px',
    },
  },
  editButton: {
    padding: '4px 15px',
    marginRight: '1rem',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  deleteButton: {
    padding: '4px 15px',
    marginLeft: '1rem',
  },
  editButtonIcon: {
    display: 'none',
    paddingRight: '.5rem',
    transform: 'translateY(2px)',
    [theme.breakpoints.down('sm')]: {
      display: 'inline',
    },
  },
  exportButton: {
    padding: '4px 15px',
    marginRight: '1rem',
  },
}));

export const FormRow = ({ form, checkable, onCheckChange, handleDelete }) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <ListItem className={classes.listItem}>
      <ListItemIcon className={classes.listIcon}>
        {getFormResponseStatusIcon(form.responseStatus)}
      </ListItemIcon>
      <ListItemText>{form.title}</ListItemText>
      {form.credentialsStartDate && (
        <ListItemText>
          <FormattedDate value={form.credentialsStartDate} />
        </ListItemText>
      )}

      <ExportMenu title={form.title} id={form.formulaResponseId} />
      <Button
        variant="contained"
        color="primary"
        size="small"
        href={`edit/${form.formId}/${form.id}/${form.formulaResponseId}`}
        className={classes.editButton}
      >
        {intl.formatMessage(messages.general_edit)}
      </Button>

      <a
        href={`edit/${form.formId}/${form.id}/${form.formulaResponseId}`}
        className={classes.editButtonIcon}
      >
        <EditRoundedIcon color="primary" fontSize="small" />
      </a>
      <ListItemSecondaryAction className={classes.secondary}>
        <DeleteButton
          id={form.id}
          handleDeleteCallback={handleDelete}
          className={classes.deleteButton}
        >
          {intl.formatMessage(messages.general_delete)}
        </DeleteButton>
        {checkable && (
          <Checkbox
            value={form.id}
            onChange={onCheckChange}
            checked={form.checked}
          />
        )}
      </ListItemSecondaryAction>
    </ListItem>
  );
};
